var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.06,
    height: 32.438,
    viewBox: "0 0 22.06 32.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1825",
    "data-name": "Group 1825",
    transform: "translate(14386 -6277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M44.475,0,40.24,24.123H33.674L37.909,0Z",
    transform: "translate(-14408.416 6277)",
    fill: "#e6001a",
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M10.842,24.053,6.566,48.45H0l4.276-24.4Z",
    transform: "translate(-14386 6260.988)",
    fill: "#e6001a",
    opacity: 0.99
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logoSmall.67f608f8c74513b8204f9b39f29b64e8.svg";
export { ForwardRef as ReactComponent };